require('./main.scss');

document.addEventListener("DOMContentLoaded", function(event) {
  history.scrollRestoration = 'manual';
  if(jQuery) {
    var $trendCapsule = $('#trend_capsule'),
      hashTag = location.hash.toLowerCase().replace(/ /g, '-');

    if($trendCapsule.length) {
      $('html, body').css({overflow: 'hidden'});

      $(window).on('load', function() {
        dataLayer.push({'event':'lp_with_videos.ready'});
      });

      setTimeout(function() {
        $trendCapsule.initVideo();
        $('#trend_loading').fadeOut();
        $('html, body').css({overflow: 'auto'});
        $(window).scrollTop(0);
        $trendCapsule.navViews(hashTag);
      });
    }
  }
});
